<script>
	import Navbar from "../Navbar.svelte";
	import Footer from "../components/Footer.svelte";
	import { handleSubmit, parseFormdata, updateNextRoute } from "../utils.js";
	import { api_writeForm, disableNextButton } from "../stores.js";
	import { useForm, validators, required } from "svelte-use-form";
	// https://svelte.dev/repl/d4fc021f688d4ad0b3ceb9a1c44c9be9?version=3.34.0

	export let redirectRoute;
	updateNextRoute();
	redirectRoute = localStorage.getItem("nextRoute");
	const form = useForm();

	const handleClick = () => {
		handleSubmit($api_writeForm, parseFormdata($form), redirectRoute);
	};

	let covidfields = [
		// covidtired
		{
			labelName: "covid-tired",
			label: "I am tired of all the COVID-19 discussions in TV shows, newspapers, and radio programs, etc.",
			options: [
				{
					type: "radio",
					value: "6_strongly-agree", // value/response to send to server
					option: "Strongly agree", // what to display
				},
				{
					type: "radio",
					value: "5_agree",
					option: "Agree",
				},
				{
					type: "radio",
					value: "4_slightly-agree",
					option: "Slightly agree",
				},
				{
					type: "radio",
					value: "3_slightly-disagree",
					option: "Slightly disagree",
				},
				{
					type: "radio",
					value: "2_disagree",
					option: "Disagree",
				},
				{
					type: "radio",
					value: "1_strongly-disagree",
					option: "Strongly disagree",
				},
			],
		},

		// covidsickhearing
		{
			labelName: "covid-sickhearing",
			label: "I am sick of hearing about COVID-19.",
			options: [
				{
					type: "radio",
					value: "6_strongly-agree", // value/response to send to server
					option: "Strongly agree", // what to display
				},
				{
					type: "radio",
					value: "5_agree",
					option: "Agree",
				},
				{
					type: "radio",
					value: "4_slightly-agree",
					option: "Slightly agree",
				},
				{
					type: "radio",
					value: "3_slightly-disagree",
					option: "Slightly disagree",
				},
				{
					type: "radio",
					value: "2_disagree",
					option: "Disagree",
				},
				{
					type: "radio",
					value: "1_strongly-disagree",
					option: "Strongly disagree",
				},
			],
		},

		// covidchangesubject
		{
			labelName: "covid-changesubject",
			label: "When friends or family members talk about COVID-19, I try to change the subject because I do not want to talk about it anymore.",
			options: [
				{
					type: "radio",
					value: "6_strongly-agree", // value/response to send to server
					option: "Strongly agree", // what to display
				},
				{
					type: "radio",
					value: "5_agree",
					option: "Agree",
				},
				{
					type: "radio",
					value: "4_slightly-agree",
					option: "Slightly agree",
				},
				{
					type: "radio",
					value: "3_slightly-disagree",
					option: "Slightly disagree",
				},
				{
					type: "radio",
					value: "2_disagree",
					option: "Disagree",
				},
				{
					type: "radio",
					value: "1_strongly-disagree",
					option: "Strongly disagree",
				},			
			],
		},
	];

	let fields = covidfields;

	// reverse options (high to low)
	//fields.forEach((field) => {
	//	field.options.reverse();
	//});

	// fields = fields.slice(fields.length - 2, fields.length);
</script>

<Navbar />

<section>
	<h1>COVID-19 fatigue</h1>
	<form use:form>
		{#each fields as field, fi}
			<div class="field-container">
				<label for={field.labelName}>{@html field.label} </label>
				{#each field.options as option, oi}
					<div class="option-group">
						<input
							name={field.labelName}
							type={option.type}
							value={option.value}
							use:validators={[required]}
						/>
						<span class="option"> {@html option.option} </span>
					</div>
				{/each}
			</div>
		{/each}

		<button
			disabled={!$form.valid && $disableNextButton}
			on:click|preventDefault={handleClick}>Next</button
		>
	</form>
</section>

<Footer />

<style>
	@media (max-width: 700px) {
		section {
			padding-left: 8%;
			padding-right: 8%;
		}
	}

	button {
		margin-bottom: 144px;
	}

	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}

	input {
		margin-right: 1px;
	}

	.field-container {
		margin-bottom: 34px;
	}

	.option {
		margin-right: 13px;
	}

	.option-group {
		display: inline;
	}

	@media (max-width: 1597px) {
		.option-group {
			display: block;
		}
	}
</style>
